import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class BaseService {
	public endPoint = '';
	readonly headers = new HttpHeaders().append('Content-Type', 'application/json');
	constructor(protected http: HttpClient) {
		this.endPoint = environment.settings.backend;
	}

	doGet<T>(url: string, params?: any): Observable<T | Response> {
 		const options = { params };
		return this.http.get<T | Response>(this.endPoint + url, options).pipe(
			take(1),
			tap((res: T | Response) => {
				return res;
			})
		);
	}

	async doPromisePost(url: string, body: any) {
		return await  this.http.post(this.endPoint + url, body).toPromise();
	}

	doPut(url: string, data: any): Observable<Response> {
		return this.http.put(this.endPoint + url, data).pipe(
			tap((res: Response) => {
				return res;
			})
		);
	}

	doPost<T>(url: string, data: any): Observable<T | Response> {
		return this.http.post(this.endPoint + url, data).pipe(
			take(1),
			tap((res: Response) => {
				return res;
			})
		);
	}

	doDelete(url: string, params?: any): Observable<Response> {
		const options = { params };
		return this.http.delete(this.endPoint + url, options).pipe(
			tap((res: Response) => {
				return res;
			})
		);
	}
}
